import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import backgroundImage from "assets/images/background.png";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fakeSection: {
      height: 64,
      position: "relative",
      [theme.breakpoints.down("sm")]: {
        height: 56,
      },
    },
    section: {
      backgroundImage: `url(${backgroundImage})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      height: "100vh",
      [theme.breakpoints.down("sm")]: {
        height: "auto",
      },
    },
    container: {
      height: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        paddingTop: "3vh",
        paddingBottom: "3vh",
        flexDirection: "column",
      },
    },
    content: {
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        textAlign: "center",
      },
    },
    title: {
      color: "white",
      [theme.breakpoints.down("sm")]: {
        fontSize: "4rem",
      },
    },
    subtitle: {
      color: "white",
      fontSize: "1.5rem",
    },
    image: {
      width: "auto",
      height: "75vh",
      maxHeight: "50rem",
      [theme.breakpoints.down("sm")]: {
        height: "60vh",
      },
    },
  }),
);

const useHomeSection = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const [t] = useTypedTranslations();

  return {
    styles,
    classes,
    atomicStyles,
    t,
  };
};

export { useHomeSection as default };
